import { SegmentedControl, Stack } from '@mantine/core';
import { ReactElement } from 'react';
import { useSearchParams } from 'react-router';
import { PatientCentralIframe } from '../shared/PatientCentralIframe';
import { PreProcedureNative } from './native/PreProcedureNative';

const SEGMENTS = ['checklist', 'native'] as const;
type PreProcedureSegment = (typeof SEGMENTS)[number];
const DEFAULT_SEGMENT: PreProcedureSegment = 'checklist';

const SEGMENT_OPTIONS: { label: string; value: PreProcedureSegment }[] = [
  { label: 'Checklist (Retool)', value: 'checklist' },
  { label: 'Checklist (native, beta)', value: 'native' },
];

function isValidSegment(value: string | null): value is PreProcedureSegment {
  return value !== null && (SEGMENTS as readonly string[]).includes(value);
}

export function PreProcedurePage(): ReactElement {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeSegment = isValidSegment(tabParam) ? tabParam : DEFAULT_SEGMENT;

  const handleSegmentChange = (value: string): void => {
    if (!isValidSegment(value)) {
      return;
    }
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('tab', value);
      return next;
    });
  };

  return (
    <Stack gap="md">
      <SegmentedControl value={activeSegment} onChange={handleSegmentChange} data={SEGMENT_OPTIONS} />
      {activeSegment === 'checklist' && (
        <PatientCentralIframe
          url="https://retool.bariendo.com/app/patient-central-medplum?_embed=true"
          title="Pre-Procedure"
        />
      )}
      {activeSegment === 'native' && <PreProcedureNative />}
    </Stack>
  );
}
